import React, {FunctionComponent} from "react";
import Layout from "../components/layout";
import {graphql} from "gatsby";
import {Post} from "../utils/models";
import Subheader from "../components/subheader";
import SEO from "../components/seo";
import PostGrid from "../components/post-grid";
import "../styles/contact-style.css";

interface ContactPageProps {
  location: Location;
}

const ContactPage: FunctionComponent<ContactPage> = ({location}) => {
  return (
    <Layout bigHeader={true}>
      <SEO
        location={location}
        title={`Contact`}
        type={`Series`}
      />
      <Subheader title={`contact`} subtitle={`contact`}/>
      <div class="title">
        <h1>¡Contacta con Nosotros!</h1>
      </div>
      <p align="center">
      <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfRxp-HHpl3ouIa7PjdXT5IzKiTNKMyF2eOVnjpQeDECsQjWg/viewform?embedded=true" width="840" height="600" frameborder="0" marginheight="0" marginwidth="0">
        Cargando…
      </iframe>
      </p>
    </Layout>
  );
}
export default ContactPage;
